import { GlobalController } from 'src/shared/global/GlobalController'
import Billing from './Billing'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'billing',
    component: Billing,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
